export const FeatureFlags = {
  CAN_CREATE_EDIT_INTERACTIVE_ACTIVITY_TYPES: 'can-create-edit-interactive-activity-types',
} as const;
